import React from "react";
import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ items, accent = false }) => (
  <div
    className={`border-y border-white/10 py-6 ${
      accent ? "bg-amber-500 text-black" : "bg-black text-zinc-400"
    }`}
  >
    <Marquee gradient={false} speed={38} pauseOnHover>
      {items.map((it, i) => (
        <span
          key={i}
          className={`mx-10 font-display uppercase tracking-tight text-3xl md:text-5xl font-black inline-flex items-center gap-10 ${
            accent ? "text-black" : ""
          }`}
        >
          {it}
          <span className={`w-2 h-2 ${accent ? "bg-black" : "bg-amber-500"} inline-block`} />
        </span>
      ))}
    </Marquee>
  </div>
);
